module.exports = __webpack_public_path__ + "img/mo_super05.68ef4d62.png";